import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CROSS } from 'src/defaultImages.js';
import { FcDiscountService } from '../../services/fc-discount.service';
import { LocalStorageService } from '../../services/localStorage.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'app-fc-discount',
  templateUrl: './fc-discount.component.html',
  styleUrls: [
    './fc-discount.component.css',
    '../add-discount/add-discount.component.css',
  ],
})
export class FcDiscountComponent implements OnInit {
  images = {
    CROSS: CROSS,
  };
  allPresetCouponsList: any;
  currentIndex: number = 0;
  selectedDiscount: { [key: string]: any } = {};
  currentId: string = '1';
  isLoading: boolean = false;
  tabsGroup: any = [];
  all: string = 'recommended';
  selectAllChecked: boolean = false;
  showSelectAll: boolean = true;
  Currency;
  isUserDetailsSet: number = 0;
  nric: string | null = null;

  constructor(
    public _dialogRef: MatDialogRef<any>,
    public _dialog: MatDialog,
    public _localStorage: LocalStorageService,
    public _fcDiscount: FcDiscountService,
    private curr: CurrencyService,
    private _messageService: MessageService
  ) {
    this.Currency = this.curr.getCurrency();
    this.isUserDetailsSet = JSON.parse(this._localStorage.get('pos_no_enter')) || 0;
    this.nric = this._localStorage.get('pos_unique_id') || null;
  }

  ngOnInit() {
    this.getCoupon();
  }
  getCoupon() {
    this.isLoading = true;
    let payload = {
      foodcourt: this._localStorage.get('restaurant_nameid'),
      cart_token: this._localStorage.get('fc_cart_token'),
      order_type: Number(this._localStorage.get('pos_order_type')),
      platform: 'pos',
    };
    this._fcDiscount.getDiscounts(payload).then((response) => {
      this.tabsGroup = response;
      this.changeTab(this.currentIndex);
      this.isLoading = false; // Set isLoading to false to hide the loader
    });
  }

  changeTab(value) {
    this.currentIndex = value;
    this.allPresetCouponsList =
      (this.tabsGroup[this.currentIndex] || {}).coupons || [];
    this.currentId = (this.tabsGroup[this.currentIndex] || {}).id || '';
    if (this.currentId === this.all) {
      const indexOfNotApplicable = this.allPresetCouponsList.some(
        (rc) => (rc || {}).is_coupon_applicable === false
      );
      if (indexOfNotApplicable) {
        this.showSelectAll = false;
      } else {
        this.showSelectAll = true;
      }
    }
  }

  discountClicked(couponId: string, restId?: string) {
    if (this.currentId === this.all) {
      if (!Array.isArray(this.selectedDiscount[this.currentId])) {
        this.selectedDiscount[this.currentId] = [];
      }

      const index = this.selectedDiscount[this.currentId].indexOf(couponId);
      if (index !== -1) {
        // If the couponId is already in the array, remove it
        this.selectedDiscount[this.currentId].splice(index, 1);
        if (!this.selectedDiscount[this.currentId].length) {
          delete (this.selectedDiscount || {})[this.currentId];
        }
        delete (this.selectedDiscount || {})[restId];
      } else {
        // If not present, add it to the array
        this.selectedDiscount[this.currentId].push(couponId);
        (this.selectedDiscount || {})[restId] = couponId;
      }
    } else {
      const couponAlreadyExist = this.selectedDiscount[restId] === couponId;
      if (couponAlreadyExist) {
        delete (this.selectedDiscount || {})[restId];
        const index = (this.selectedDiscount[this.all] || []).indexOf(couponId);
        if (index !== -1) {
          this.selectedDiscount[this.all].splice(index, 1);
        }
      } else {
        const couponExistInRecommended = this.tabsGroup
          .find((tg) => tg.id === this.all)
          .coupons.find((c) => c.id === couponId);
        if (couponExistInRecommended) {
          if (Array.isArray(this.selectedDiscount[this.all])) {
            this.selectedDiscount[this.all].push(couponId);
          } else {
            this.selectedDiscount[this.all] = [couponId];
          }
        }
        (this.selectedDiscount || {})[restId] = couponId;
        const recommendedRestCoupon = this.tabsGroup
          .find((tg) => tg.id === this.all)
          .coupons.find((c) => c.data.restaurant_id === restId).id;
        const index = (this.selectedDiscount[this.all] || []).indexOf(
          recommendedRestCoupon
        );
        if (recommendedRestCoupon !== couponId && index !== -1) {
          this.selectedDiscount[this.all].splice(index, 1);
        }
      }
    }
    this.selectAllChecked =
      (this.selectedDiscount[this.all] || []).length ===
      (this.allPresetCouponsList || []).length;
  }
  selectAll() {
    if (this.selectAllChecked) {
      this.selectAllChecked = !this.selectAllChecked;
      return (this.selectedDiscount = {});
    }
    this.selectedDiscount = { ...this.tabsGroup[0].recommended_mapping };
    let recommendedValues = Object.values(
      this.tabsGroup[0].recommended_mapping
    );
    // Assuming this.selectedDiscount is an object (initialized or not)
    (this.selectedDiscount || {})[this.all] = recommendedValues;
    this.selectAllChecked = !this.selectAllChecked;
  }
  searchQueryChange(event: string) {
    // Filter coupons based on the search filter
    this.allPresetCouponsList = this.filterCoupons(event);
  }

  filterCoupons(searchTerm: string): string[] {
    this.allPresetCouponsList = this.tabsGroup[this.currentIndex].coupons;
    // If the search term is empty, return all coupons
    if (!searchTerm.trim()) {
      return (this.allPresetCouponsList =
        this.tabsGroup[this.currentIndex].coupons);
    }

    // Filter coupons based on the search term (case insensitive)
    return this.allPresetCouponsList.filter((coupon) =>
      coupon.data.code.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  cancelClicked() {
    this._dialogRef.close({ status: 0, data: null, message: 'closed' });
  }
  submit() {
    // Check if the selected discount is a special preset by invoking checkSpecialPreset method
    const isSpecialPreset = this.checkSpecialPreset(this.selectedDiscount, this.tabsGroup);

    if (isSpecialPreset) {
      // If user details have not been set
      if (!this.isUserDetailsSet) {
        // Show an error message indicating that user details need to be added
        this._messageService.showError('Please add user details first with NRIC number to apply special preset');

        // Close the dialog and return with a message to open the user form
        return this._dialogRef.close({
          message: 'open_user_form'
        });
      }

      // If NRIC number is not available
      if (!this.nric) {
        // Show an error message indicating that a valid NRIC number is required
        return this._messageService.showError('No valid NRIC number found to apply special preset');
      }
    }

    let payload = {
      foodcourt: this._localStorage.get('restaurant_nameid'),
      token: this._localStorage.get('fc_cart_token'),
      order_type: +this._localStorage.get('pos_order_type'),
      restaurant_coupon_data: this.createPayload(this.selectedDiscount),
      platform: 'pos',
      user_nric_id: this.nric
    };
    this._fcDiscount.applyDiscount(payload).then((response) => {
      if (response) {
        this._dialogRef.close({ status: 1, data: null, message: 'applied' });
      }
    });
  }
  createPayload(data) {
    const arrayOfObjects = Object.entries(data).map(([key, value]) => ({
      restaurant_id: key,
      coupon_id: value,
    }));
    console.log(arrayOfObjects);
    return arrayOfObjects;
  }
  hasSelectedDiscount(): boolean {
    return Object.keys(this.selectedDiscount).length > 0;
  }

  checkSpecialPreset(selectedDiscount, allCoupons) {
    // Iterate over the keys in selectedDiscount
    for (const key in selectedDiscount) {
        // Skip if the key is "recommended" (as it's an array)
        if (key === "recommended") continue;

        const selectedCouponId = selectedDiscount[key];

        // Find the corresponding coupon object in allCoupons based on the restaurant ID (key)
        const restaurantCoupons = allCoupons.find((restaurant) => restaurant.id === key);
        
        if (restaurantCoupons) {
            // Find the coupon object in the restaurant's coupons array based on the coupon ID
            const coupon = restaurantCoupons.coupons.find(coupon => coupon.id === selectedCouponId);
            
            // If the coupon is found and the is_special_preset is 1, return true
            if (coupon && coupon.data.is_special_preset === 1) {
                return true;
            }
        }
    }

    // Return false if no matching coupon with is_special_preset is found
    return false;
}
}
